export default "__VITE_ASSET__9eb1af44__"